<script setup></script>

<template>
  <svg
    class="w-full"
    viewBox="0 0 111 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M110.354 4.35355C110.549 4.15829 110.549 3.84171 110.354 3.64645L107.172 0.464466C106.976 0.269204 106.66 0.269204 106.464 0.464466C106.269 0.659728 106.269 0.976311 106.464 1.17157L109.293 4L106.464 6.82843C106.269 7.02369 106.269 7.34027 106.464 7.53553C106.66 7.7308 106.976 7.7308 107.172 7.53553L110.354 4.35355ZM0 4.5H110V3.5H0V4.5Z"
      fill="#061F5F"
    />
  </svg>
</template>

<style scoped></style>
